import type { HelpSection } from '@/content/help/types';
import { cn } from '@/lib/utils';

interface HelpSectionNavProps {
  sections: HelpSection[];
  activeSection?: string;
  onSectionClick: (sectionId: string) => void;
}

export function HelpSectionNav({
  sections,
  activeSection,
  onSectionClick,
}: HelpSectionNavProps) {
  if (sections.length === 0) {
    return null;
  }

  return (
    <nav className="mb-4">
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">
        Jump to
      </p>
      <ul className="flex flex-wrap gap-1.5">
        {sections.map((section) => (
          <li key={section.id}>
            <button
              onClick={() => onSectionClick(section.id)}
              className={cn(
                'px-2.5 py-1 text-xs rounded-full border transition-colors',
                activeSection === section.id
                  ? 'bg-primary-50 border-primary-200 text-primary-700'
                  : 'bg-muted border-border text-muted-foreground hover:bg-muted hover:border-border'
              )}
            >
              {section.title}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
